export default __webpack_public_path__ + "static/media/covalent-logo.bd354a71.svg";